<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10 align-self-center">
      <h2>{{ $t("navigations.cra dashboard") }}</h2>
    </div>
  </div>
<div class="row mt-3">
  <div class="col-lg-6">
    <div class="dash-widget cursor-pointer">
      <div class="row">
        <div class="col-8 text-left">
          <h4>{{ $t('navigations.high risk sites') }}</h4>
          <h1 class="font-bold">{{ highriskcount || 0 }}</h1>
        </div>
        <div class="col-4 justify-content-center align-self-center">
          <img src="../../assets/img/db_open_queries.png" alt="High Risk Sites">
        </div>
      </div>
    </div>
  </div>

  <div class="col-lg-6">
    <div class="dash-widget cursor-pointer">
      <div class="row">
        <div class="col-8 text-left">
          <h4>{{ $t('navigations.overdue visits') }}</h4>
          <h1 class="font-bold">{{ overduevisitscount || 0 }}</h1>
        </div>
        <div class="col-4 justify-content-center align-self-center">
          <img src="../../assets/img/db_totalsites.png" alt="Overdue Visits">
        </div>
      </div>
    </div>
  </div>
</div>
  <div class="row mt-3">
    <div class="col-lg-4">
      <div class="ibox">
        <div class="ibox-title">
          <h5 class="text-white">High-Risk Site Overview</h5>
        </div>

        <div class="ibox-content" v-if="selectedSite">
          <h4>Site: {{ selectedSite.siteCode }}</h4>

          <p class="mt-2">
            <strong>Site Risk Score:</strong>
            {{ selectedSite.siteScore }}
          </p>

          <p>
            <strong>Status:</strong>
            {{ selectedSite.status }}
          </p>

          <hr />

          <h5>Key Risk Indicators</h5>

          <div v-for="risk in keyRisks" :key="risk.riskName"
            class="d-flex justify-content-between align-items-center mb-2">
            <div>
              <div><strong>{{ risk.riskName }}</strong></div>
              <small>Score: {{ risk.score }}</small>
            </div>

            <span class="badge" :style="{ backgroundColor: risk.riskLevelColor, color: '#fff' }">
              {{ risk.riskLevelLabel }}
            </span>
          </div>
        </div>

        <div class="ibox-content text-muted" v-else>
          No high-risk site available
        </div>
      </div>
    </div>

  <div class="col-lg-8">
      <div class="ibox">
        <div class="ibox-title d-flex justify-content-between">
          <h5 class="text-white">CRA Schedule</h5>
        </div>

        <div class="ibox-content">
          <!-- Calendar Component -->
          <vue-cal
  style="height: 380px"
  default-view="month"
  :events="craEvents"
  events-on-month-view="short"
  event-style="background"
  :tooltip="false"
  :disable-views="['years', 'year', 'week', 'day']"
>
  <template #event="{ event }">
    <!-- Dots -->
    <div class="dot-container">
      <span
        v-for="(visit, i) in event.visits"
        :key="i"
        class="visit-dot planned"
        :class="visit.monitoringMode.toLowerCase()"
      />
    </div>

    <!-- Tooltip -->
    <div class="custom-tooltip">
      <div
        v-for="(visit, i) in event.visits"
        :key="i"
        class="tooltip-row"
      >
        <strong>{{ visit.siteCode }}</strong>
        <span>
          — {{ visit.monitoringMode }}
          <em>(Planned)</em>
        </span>
      </div>
    </div>
  </template>
</vue-cal>





          <div class="mt-3 d-flex justify-content-between align-items-center">
  
  <!-- Color legend -->
  <div class="d-flex gap-3">
    <span><i class="fa fa-square text-success"></i> Hybrid Visit</span>
    <span><i class="fa fa-square text-info"></i> Remote Visit</span>
    <span><i class="fa fa-square text-danger"></i> On-Site Visit</span>
  </div>

  <!-- Shape legend -->
  <div class="d-flex gap-3 align-items-center">
    <span class="d-flex align-items-center">
      <span class="visit-dot planned legend-dot"></span>
      <span class="ms-1">Planned Date</span>
    </span>

    <!-- <span class="d-flex align-items-center">
      <span class="visit-dot immediate legend-dot"></span>
      <span class="ms-1">Immediate Date</span>
    </span> -->
  </div>

</div>

        </div>
      </div>
    </div>
  </div>

 <div class="row mt-3">
<div ref="captureArea2" class="col-md-12 mb-2 pl-1">

    <barchart v-if="data.length > 0" :loader="false" :data="data" xAxisKey="siteCode" :width="1200"
      colorkey="riskLevelColor" :barlabelvertical="true" xAxisLabel="Site Code" categoryfield="riskLevelLabel"
      yAxisKey="score" yAxisLabel="Score" :showcatoptions="false" :drilldowneabled="true"
      :fromPage="'descriptiveStatistics'" chartlabel="Site Comparison of Risk Scores" />
  </div>
 </div>
  
  <div class="row g-3 mb-4">
    <div class="col-12">
      <div class="card chart-container">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <div>
              <h4 class="mb-0">High Risk Flags by Site</h4>
              <p class="text-muted small"></p>
            </div>
            <button class="btn btn-primary" @click="toggleLegend">{{ legendButtonText }}</button>
          </div>
          <!-- KPI Legend -->
  <div class="kpi-legend" id="kpiLegend">
    <h3>KPI Legend</h3>
    <table>
      <thead>
        <tr>
          <th>KPI</th>
          <th>Weightage</th>
          <th>Reason</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>SAE Rate</td>
          <td><span class="badge high">1.00</span></td>
          <td>Direct patient safety</td>
        </tr>
        <tr>
          <td>Timeliness of data entry (SAEs)</td>
          <td><span class="badge high">0.90</span></td>
          <td>Regulatory reporting</td>
        </tr>
        <tr>
          <td>Major Protocol Deviation Rate</td>
          <td><span class="badge high">0.85</span></td>
          <td>GCP compliance</td>
        </tr>
        <tr>
          <td>Query aging (critical DP)</td>
          <td><span class="badge medium">0.80</span></td>
          <td>Data integrity</td>
        </tr>
        <tr>
          <td>Missing visits</td>
          <td><span class="badge medium">0.70</span></td>
          <td>Monitoring gap</td>
        </tr>
        <tr>
          <td>Enrollment rate</td>
          <td><span class="badge low">0.60</span></td>
          <td>Operational</td>
        </tr>
        <tr>
          <td>Subject discontinuation rate</td>
          <td><span class="badge low">0.60</span></td>
          <td>Study power</td>
        </tr>
        <tr>
          <td>Site Issue Outlier</td>
          <td><span class="badge low">0.50</span></td>
          <td>Statistical anomaly</td>
        </tr>
      </tbody>
    </table>
  </div>
  <!-- KPI Legend End -->
          <div style="height: 320px;">
            <canvas ref="highRiskBarChart"></canvas>
          </div>
        </div>
      </div>
    </div>
  </div>


</template>
<script src="./cra_dashboard.js"></script>

<style scoped>
@import "../../custom_lib/AiCharts/charts.css";
:deep(.vuecal__event.on-site) {
  background-color: #ff0202 !important;
  color: #fff;
}
.kpi-legend {
      max-width: 800px;
      background: #ffffff;
      border-radius: 12px;
      padding: 15px;
      box-shadow: 0 2px 10px rgba(0,0,0,0.08);
      display: none; /* hidden by default */
    }

    .kpi-legend h3 {
      margin-top: 0;
      color: #333;
      margin-bottom: 12px;
    }
    .badge {
      padding: 4px 8px;
      border-radius: 6px;
      font-size: 0.85rem;
      font-weight: bold;
      display: inline-block;
      min-width: 45px;
      text-align: center;
    }

    .high {
      background-color: #ffe5e5;
      color: #c0392b;
    }

    .medium {
      background-color: #fff3cd;
      color: #d68910;
    }

    .low {
      background-color: #e8f5e9;
      color: #2e7d32;
    }
.chart-container {
  border-radius: 6px;
}
.custom-event {
  cursor: pointer;
  position: relative;
}

:deep(.vuecal__event),
:deep(.vuecal__event-content) {
  overflow: visible !important;
}

.dot-container {
  display: flex;
  gap: 4px;
  justify-content: center;
}
.legend-dot {
  margin-right: 4px;
  background-color: #555;
}

/* already existing */
.visit-dot {
  width: 8px;
  height: 8px;
  display: inline-block;
  border-radius: 50%;
}

/* Immediate → diamond */
.visit-dot.immediate {
  border-radius: 2px;
  transform: rotate(45deg);
}


.visit-dot {
  width: 8px;
  height: 8px;
  display: inline-block;
  margin-right: 3px;
  border-radius: 50%; /* circle */
}

/* Immediate date → diamond */
.visit-dot.immediate {
  border-radius: 2px;
  transform: rotate(45deg);
}

/* (optional) slightly larger for visibility */
.visit-dot.immediate {
  width: 9px;
  height: 9px;
}



.visit-dot.onsite { background: #ff0202; }
.visit-dot.remote { background: #6db0fd; }
.visit-dot.hybrid { background: #05b831; }

.custom-tooltip {
  position: absolute;
  bottom: 120%;
  left: 50%;
  transform: translateX(-50%);
  background: #000;
  color: #fff;
  padding: 8px 10px;
  border-radius: 6px;
  font-size: 12px;
  min-width: 220px;
  opacity: 0;
  visibility: hidden;
  z-index: 9999;
}

.tooltip-row {
  padding: 4px 0;
  border-bottom: 1px solid rgba(255,255,255,0.15);
}
.tooltip-row:last-child {
  border-bottom: none;
}

:deep(.vuecal__event:hover) .custom-tooltip {
  opacity: 1;
  visibility: visible;
}


:deep(.vuecal__event) {
  overflow: visible !important;
}

:deep(.vuecal__event-content) {
  overflow: visible !important;
}

.custom-event:hover .custom-tooltip {
  opacity: 1;
  visibility: visible;
}

:deep(.vuecal__event.risk-triggered) {
  background-color: #ed5565 !important;
  color: #fff;
}

:deep(.vuecal__event.remote) {
  background-color: #6db0fd !important;
  color: #fff;
}
:deep(.vuecal__event.hybrid) {
  background-color: #05b831 !important;
  color: #fff;
}
:deep(.vuecal__month-view .vuecal__event) {
  position: absolute;
  inset: 2px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
}

.widget {
  margin-top: 0rem;
  margin-bottom: 0rem;
}

.widgetmargin {
  margin-top: -13px !important;
}

.style1 {
  background-color: black !important;
  color: #ffffff;
}

.btn-view {
  color: #fff !important;
  background-color: #bb458f !important;
  border-color: #bb458f !important;
}

.btn-view:hover {
  color: #fff;
  background-color: #666ccb;
  border-color: #666ccb;
}

.btn-view:active {
  color: rgb(255, 255, 255) !important;
  background-color: #dda2c7 !important;
  border-color: #dda2c7 !important;
}

.titlemsg {
  border-color: #e7eaec;
  margin-bottom: 0;
  padding: 20px 20px;
  position: relative;
  clear: both;
  right: 0;
  margin-right: 0px;
  margin-left: 0px !important;
  margin-top: 0px !important;
  padding-left: 10px;
}

.padding_bottom {
  padding-bottom: 2rem;
}

.ibox-title h5 {
  height: 0rem;
  padding: 0rem;
}

.ibox-title h5:hover {
  background-color: inherit;
  padding: 0;
  cursor: not-allowed;
}

.titlemsg {
  font-size: 15px;
  font-weight: bold;
  color: var(--primary-color);
}

.switchbtn {
  background-color: #bb458f !important;
  height: max-content;
  border-color: #bb458f !important;
  color: white !important;
  float: right;
}

.switchbtn:active {
  height: max-content;
  border-color: #bb458f !important;
  color: white !important;
  float: right;
  background-color: #bb458f;
}

.switchbtn:hover {
  height: max-content;
  border-color: #bb458f !important;
  color: white !important;
  float: right;
  background-color: #bb458f;
}

.queryhover:hover {
  color: #3c4192 !important;
  -webkit-transition: color ease-in 400ms;
  transition: color ease-in 400ms;
  cursor: pointer;
}

.widgetminheight {
  min-height: 102px;
}

.graphbutton {
  width: fit-content;
  padding: 3px;
  cursor: pointer;
}

.graphbtncontainer {
  display: flex;
  gap: 5px;
}

img {
  margin-left: 0px !important;
}

.selectdefault {
  left: 0;
}

.btn:focus {
  outline: none;
  box-shadow: none;
}

.btn-setdefault {
  position: relative;
  padding: 0.2rem 0.4rem;
  text-align: center;
  font-size: 0.7rem;
  background-color: #ec4758;
  color: white !important;
  border-radius: 3px;
}

.ibox-content h1 {
  font-weight: 400;
  color: #676a6c;
}
</style>
